const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
/* ===============================
   SF SHIPPING TIMELINE (COMPACT) - BUSINESS DAYS
   Empaque: Lunes a Sábado
   Corte: 2:00 pm (cámbialo abajo)
   Nacional: 2–5 días hábiles (no cuenta domingo)
================================ */

document.addEventListener("DOMContentLoaded", () => {
  const roots = document.querySelectorAll("[data-sf-ship]");
  if (!roots.length) return;

  const locale = "es-CO";

  // ✅ AJUSTA AQUÍ TU HORA LÍMITE:
  // Si tu corte es 1 pm => cutoffHour = 13
  // Si tu corte es 2 pm => cutoffHour = 14
  const cutoffHour = 14;       // 2:00 pm
  const cutoffMinute = 0;

  // Nacional (días HÁBILES)
  const shipMinBusinessDays = 2;
  const shipMaxBusinessDays = 5;

  const pad = (n) => String(n).padStart(2, "0");
  const fmt = (d) => d.toLocaleDateString(locale, { month: "short", day: "numeric" });

  function isBusinessDay(d) {
    const day = d.getDay(); // 0=Dom, 1=Lun ... 6=Sab
    return day >= 1 && day <= 6; // Lun-Sab
  }

  function startOfDay(d) {
    const x = new Date(d);
    x.setHours(0, 0, 0, 0);
    return x;
  }

  function setTime(d, h, m) {
    const x = new Date(d);
    x.setHours(h, m, 0, 0);
    return x;
  }

  function nextBusinessDay(d) {
    let x = startOfDay(d);
    // avanza hasta encontrar Lun-Sab
    while (!isBusinessDay(x)) {
      x.setDate(x.getDate() + 1);
    }
    return x;
  }

  function addBusinessDays(d, businessDays) {
    let x = startOfDay(d);
    let added = 0;
    while (added < businessDays) {
      x.setDate(x.getDate() + 1);
      if (isBusinessDay(x)) added += 1;
    }
    return x;
  }

  function computeProcessingStart(now) {
    // Si hoy no es hábil (domingo), arranca el próximo hábil
    const todayStart = startOfDay(now);
    const todayIsBusiness = isBusinessDay(todayStart);

    // Cutoff de "hoy" (en la hora local del navegador)
    const todayCutoff = setTime(todayStart, cutoffHour, cutoffMinute);

    // Si hoy es hábil y estás antes del corte => procesa hoy
    if (todayIsBusiness && now.getTime() <= todayCutoff.getTime()) {
      return todayStart;
    }

    // Si ya pasó el corte o es domingo => siguiente día hábil
    const tomorrow = new Date(todayStart);
    tomorrow.setDate(tomorrow.getDate() + 1);
    return nextBusinessDay(tomorrow);
  }

  function computeNextCutoff(now) {
    const todayStart = startOfDay(now);
    const todayCutoff = setTime(todayStart, cutoffHour, cutoffMinute);

    // Si hoy es hábil y aún no pasa el corte => cutoff hoy
    if (isBusinessDay(todayStart) && now.getTime() <= todayCutoff.getTime()) {
      return todayCutoff;
    }

    // Si no, cutoff del próximo día hábil
    const tomorrow = new Date(todayStart);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const nextBiz = nextBusinessDay(tomorrow);
    return setTime(nextBiz, cutoffHour, cutoffMinute);
  }

  function cutoffPrefixText(now, nextCutoffDate) {
    // Si nextCutoff es hoy => "Pide antes de"
    const today = startOfDay(now).getTime();
    const cutDay = startOfDay(nextCutoffDate).getTime();

    if (cutDay === today) return "Pide antes de";

    // Si es mañana => "Pide antes de mañana"
    const tomorrow = new Date(startOfDay(now));
    tomorrow.setDate(tomorrow.getDate() + 1);
    if (startOfDay(tomorrow).getTime() === cutDay) return "Pide antes de mañana";

    // Si es lunes por salto de domingo/sábado => "Pide antes del lunes"
    const weekday = nextCutoffDate.toLocaleDateString(locale, { weekday: "long" });
    return `Pide antes del ${weekday}`;
  }

  function update(root) {
    const now = new Date();

    const processingStart = computeProcessingStart(now); // día en que empacamos/despachamos
    const nextCutoff = computeNextCutoff(now);

    // Entrega nacional 2–5 días HÁBILES desde processingStart
    const deliveryFrom = addBusinessDays(processingStart, shipMinBusinessDays);
    const deliveryTo = addBusinessDays(processingStart, shipMaxBusinessDays);

    // Mostrar fechas
    root.querySelector("[data-sf-buy]").textContent = fmt(startOfDay(now));
    root.querySelector("[data-sf-from]").textContent = fmt(deliveryFrom);
    root.querySelector("[data-sf-to]").textContent = fmt(deliveryTo);

    // Preparación: mostramos el día de proceso (compacto)
    // Si quieres rango “hoy–mañana” lo puedo ajustar, pero esto es más limpio.
    root.querySelector("[data-sf-prep]").textContent = fmt(processingStart);

    root.querySelector("[data-sf-delivery]").textContent = `${fmt(deliveryFrom)}–${fmt(deliveryTo)}`;

    // Countdown
    const cdEl = root.querySelector("[data-sf-countdown]");
    const prefix = root.querySelector("[data-sf-prefix]");

    const diff = Math.max(0, nextCutoff.getTime() - now.getTime());
    const totalSec = Math.floor(diff / 1000);
    const h = Math.floor(totalSec / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    const s = totalSec % 60;

    cdEl.textContent = `${pad(h)}:${pad(m)}:${pad(s)}`;
    prefix.textContent = cutoffPrefixText(now, nextCutoff);
  }

  roots.forEach(update);
  setInterval(() => roots.forEach(update), 1000);
});

